import Scene from './Scene';
import UICarousel from '../ui/UICarousel';
import commonGame from '../commonGame';
import common from '../common';

const _createButtons = Symbol('_createButtons');
const _createBackground = Symbol('_createBackground');
const _onCarouselIndex_Changed = Symbol('_onCarouselIndex_Changed');
const _prevClick = Symbol('_prevClick');
const _nextClick = Symbol('_nextClick');
const _backClick = Symbol('_backClick');
const _playClick = Symbol('_playClick');
const _updateUI = Symbol('_updateUI');

export default class ImageSelectionScene extends Scene {
	constructor() {
		super();
		// Constants.
		this.ARR_COLOUR_IT_TEXT_ID = [
		];

		this.ARR_DRAW_IT_TEXT_ID = [
		];

		const a = common.levelConfig.outlines;
		for (let i = 0; i < a.draw_it.length; i++)
			this.ARR_DRAW_IT_TEXT_ID.push(i + 1);

		for (let i = 0; i < a.colour_it.length; i++)
			this.ARR_COLOUR_IT_TEXT_ID.push(i + 1);

		let prefix = commonGame.selectedGallery === commonGame.GALLERY_ID_COLOUR_IT ? 'colour_' : 'draw_';
		this._arrayToUse = prefix === 'colour_' ? this.ARR_COLOUR_IT_TEXT_ID : this.ARR_DRAW_IT_TEXT_ID;

		this.ARR_IMAGE_SPRITE_ID = [];//from legacy project, working around//--
		this._imageLength = this._arrayToUse.length;
		console.log(this._arrayToUse, this._imageLength, commonGame.GALLERY_ID_COLOUR_IT);

		for (let i = 0; i < this._imageLength; i++)
			this.ARR_IMAGE_SPRITE_ID.push('image_' + (i + 1));

		// Attributes.
		this._titleSprite = null;
		this._titleText = null;

		// UI.
		this._playBtn = null;
		this._prevImageBtn = null;
		this._nextImageBtn = null;
		this._backBtn = null;
		this._muteBtn = null;
		this._uiCarousel = null;
	}

	init() {
		super.init();

		this[_createBackground]();

		this._arrayPrefix = commonGame.selectedGallery === commonGame.GALLERY_ID_COLOUR_IT ? 'colour_it' : 'draw_it';
		const arrCarouselItem = [];
		const outlineArray = common.levelConfig.outlines[this._arrayPrefix];
		// Carousel items.
		for (const outlineArrayElement of outlineArray) {
			// Container.
			const carouselItem = new PIXI.Container();
			carouselItem.scale = new PIXI.Point(0.6, 0.6);
			carouselItem.anchor = new PIXI.Point(0.5, 0.5);

			carouselItem.addChild(commonGame.createCanvasBg(common.levelConfig.gallery_select.frame.texture));

			// Bg.
			const bgSprite = new PIXI.Sprite(PIXI.Texture.WHITE);
			bgSprite.anchor.set(0.5);
			bgSprite.width = commonGame.CANVAS_WIDTH;
			bgSprite.height = commonGame.CANVAS_HEIGHT;
			bgSprite.tint = 0xffffff;

			carouselItem.addChild(bgSprite);

			let galleryKey = commonGame.selectedGallery === 1 ? 'colour_it' : 'draw_it';

			// Border.
			const borderSprite = new PIXI.Sprite(P3.assets.texture(
				common.levelConfig.gallery_select.frame[galleryKey]
			));
			borderSprite.anchor.set(0.5);
			borderSprite.scale.set(1.42, 1.45);
			carouselItem.addChild(borderSprite);

			// Sprite.
			const imageSprite = new PIXI.Sprite(P3.assets.texture(outlineArrayElement));
			imageSprite.anchor.set(0.5);
			carouselItem.addChild(imageSprite);

			arrCarouselItem.push(carouselItem);
		}

		// UICarousel.
		this._uiCarousel = new UICarousel();
		this._uiCarousel.init(arrCarouselItem);
		this._uiCarousel.signals.onIndexChanged.add(this[_onCarouselIndex_Changed], this);
		this._uiCarousel.signals.onItemSelected.add(this[_playClick], this);
		this.addChild(this._uiCarousel);

		this[_createButtons]();
	}

	appear() {
		this.animateIn();
	}

	animateIn() {
		this._uiCarousel.animateIn();

		new P3.utils.TWEEN.Tween(this._muteBtn.scale, this.tweens)
			.to({
				x: 1, y: 1
			}, 340)
			.delay(200)
			.easing(P3.utils.Easing.Back2.Out)
			.onUpdate(()=> {
				this._backBtn.scale = this._muteBtn.scale;
			})
			.start();

		new P3.utils.TWEEN.Tween(this._playBtn.scale, this.tweens)
			.to({
				x: 1, y: 1
			}, 340)
			.delay(200)
			.easing(P3.utils.Easing.Back3.Out)
			.onUpdate(()=> {
				this._playBtn.alpha = this._playBtn.scale.x;
			})
			.start();
	}

	destroy(options) {
		// clean up goes here
		super.destroy();
	}

	resize() {
		super.resize();
		this._muteBtn.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 70;
		this._backBtn.x = (common.STAGE_WIDTH - P3.View.width) * 0.5 + 70;
	}

	update() {
		super.update();
		this._uiCarousel.update();
	}

	[_updateUI]() {
		// Prev.
		this._prevImageBtn.interactive = this._uiCarousel.selectedIndex > 0;
		new P3.utils.TWEEN.Tween(this._prevImageBtn, this.tweens)
		    .to({
				alpha: this._prevImageBtn.interactive ? 1 : 0
		    }, 250)
		    .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
		    .start();

		// Next.
		this._nextImageBtn.interactive = this._uiCarousel.selectedIndex < this._imageLength - 1;
		new P3.utils.TWEEN.Tween(this._nextImageBtn, this.tweens)
			.to({
				alpha: this._nextImageBtn.interactive ? 1 : 0
			}, 250)
			.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
			.start();
	}

	[_createBackground]() {
		const bgConfig = common.levelConfig.gallery_select.bg;

		for (const bgConfigElement of bgConfig)
			this.addChild(common.createSprite(bgConfigElement));
	}

	[_createButtons]() {
		//backBtn
		this._backBtn = createButton('back');
		this._backBtn.anchor = new PIXI.Point(0.5, 0.5);
		this._backBtn.position = new PIXI.Point(
			(common.STAGE_WIDTH - P3.View.width) * 0.5 + 70,
			this._backBtn.height * 0.5 + 30
		);
		this._backBtn.overSoundName = 'sfx_ui_rollover_00';
		this._backBtn.downSoundName = 'sfx_btn_play_start_doorbell_00';
		this._backBtn.signals.click.once(this[_backClick], this);
		this._backBtn.scale.set(0);
		this.addChild(this._backBtn);

		//mute btn
		const states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_primary_small_' + 'off');
		states.over = P3.assets.texture('btn_primary_small_' + 'over');
		states.down = P3.assets.texture('btn_primary_small_' + 'down');
		states.icon = P3.assets.texture('icon_sound');
		states.iconAlt = P3.assets.texture('icon_mute');

		this._muteBtn = new P3.MuteButton(states);

		this._muteBtn.position = new PIXI.Point(
			(common.STAGE_WIDTH + P3.View.width) * 0.5 - 70,
			this._muteBtn.height * 0.5 + 30
		);
		this._muteBtn.scale.set(0);
		this.addChild(this._muteBtn);

		// Play button.
		this._playBtn = createButton('play', 'primary_large');
		this._playBtn.anchor = new PIXI.Point(0.5, 0.5);
		this._playBtn.position = new PIXI.Point(
			common.STAGE_WIDTH * 0.5,
			common.STAGE_HEIGHT * 0.5 + 220
		);
		this._playBtn.overSoundName = 'sfx_ui_rollover_00';
		this._playBtn.downSoundName = 'sfx_btn_play_start_doorbell_00';
		this._playBtn.signals.click.once(this[_playClick], this);
		this._playBtn.scale.set(0);
		this._playBtn.alpha = 0;
		this.addChild(this._playBtn);

		// Next image button.
		let btnStatesAux = new P3.ButtonStates(
			P3.assets.texture('btn_arrow_out'),
			P3.assets.texture('btn_arrow_over'),
			P3.assets.texture('btn_arrow_down')
		);

		this._nextImageBtn = new P3.Button(btnStatesAux);
		this._nextImageBtn.anchor = new PIXI.Point(0.5, 0.5);
		this._nextImageBtn.scale = new PIXI.Point(1.5, 1.5);
		//this._nextImageBtn.defaultScale = new PIXI.Point(1.5, 1.5);
		this._nextImageBtn.position = new PIXI.Point(
			common.STAGE_WIDTH * 0.5 + 400,
			common.STAGE_HEIGHT * 0.5);
		this._nextImageBtn.signals.click.add(this[_nextClick], this);
		this.addChild(this._nextImageBtn);

		// Prev image button.
		btnStatesAux = new P3.ButtonStates(
			P3.assets.texture('btn_arrow_out'),
			P3.assets.texture('btn_arrow_over'),
			P3.assets.texture('btn_arrow_down')
		);

		this._prevImageBtn = new P3.Button(btnStatesAux);
		this._prevImageBtn.anchor = new PIXI.Point(0.5, 0.5);
		this._prevImageBtn.scale = new PIXI.Point(-1.5, 1.5);
		this._prevImageBtn.alpha = 0;

		//this._prevImageBtn.defaultScale = new PIXI.Point(-1.5, 1.5);
		this._prevImageBtn.position = new PIXI.Point(
			common.STAGE_WIDTH * 0.5 - 400,
			common.STAGE_HEIGHT * 0.5);
		this._prevImageBtn.signals.click.add(this[_prevClick], this);
		this.addChild(this._prevImageBtn);

		this[_updateUI]();
	}

	[_onCarouselIndex_Changed]() {
		this[_updateUI]();
	}

	[_prevClick]() {
		this._uiCarousel.prev();
	}

	[_nextClick]() {
		this._uiCarousel.next();
	}

	[_backClick]() {
		this.signals.previous.dispatch();
	}

	[_playClick]() {
		commonGame.selectedImageId = this._uiCarousel.selectedIndex + 1;
		commonGame.selectImage = common.levelConfig.outlines[this._arrayPrefix][this._uiCarousel.selectedIndex];
		this.signals.next.dispatch();
	}
}
